<template>
  <div class="index_wrapper">
    <div style="display: flex; justify-content: space-between">
      <div class="title">编辑</div>
      <a-button type="primary" @click="back"> 返回 </a-button>
    </div>
    <div class="content">
      <div class="subTil">商品关键信息</div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 14 }"
      >
        <div class="form">
          <a-form-model-item label="商品类别" prop="goodsTypeString">
            <a-button
              type="primary"
              checked
              v-if="form.goodsTypeString === 'PHYSICAL'"
            >
              实物商品
            </a-button>
            <a-button type="primary" checked v-else> 虚拟商品 </a-button>
          </a-form-model-item>
          <a-form-model-item
            ref="name"
            label="商品名称"
            prop="name"
            :labelCol="{ span: 2 }"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              v-model="form.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur()
                }
              "
              ref="nameInputValue"
              @keyup="nameInpNum"
            />
            <span class="inpNum">{{ inpNum }}/30</span>
          </a-form-model-item>
          <a-form-model-item
            label="选择优惠券"
            v-if="form.goodsTypeString === 'VIRTUAL'"
            prop="specification"
          >
            <div style="display: flex">
              <a-input v-model="couponShowName" disabled />
              <a-button type="primary" @click="chooseVirtualGoods('')"
                >浏览...</a-button
              >
            </div>
          </a-form-model-item>
          <a-form-model-item label="商品分类" prop="categoryId">
            <a-select
              v-model="form.categoryId"
              @change="selectClassify"
              placeholder="请选择商品分类"
            >
              <a-select-option
                v-for="(item, i) in categoryList"
                :key="i"
                :value="item.code"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="规格">
            <a-input v-model="form.specification" />
          </a-form-model-item>
          <a-form-model-item label="成本价">
            <div style="position: relative">
              <a-input v-model="form.costPrice" />
              <span style="position: absolute; right: 15px">元</span>
            </div>
          </a-form-model-item>
          <a-form-model-item label="商品原价" prop="basePrice">
            <div style="position: relative">
              <a-input v-model="form.basePrice" />
              <span style="position: absolute; right: 15px">元</span>
            </div>
          </a-form-model-item>
          <a-form-model-item label="商品折扣价" prop="discountPrice">
            <div style="position: relative">
              <a-input v-model="form.discountPrice" />
              <span
                v-if="buyType === 'CASH'"
                style="position: absolute; right: 15px"
                >元</span
              >
              <span v-else style="position: absolute; right: 15px">分</span>
            </div>
          </a-form-model-item>
          <!-- <a-form-model-item label="运费" prop="transExpense">
            <a-input v-model="form.transExpense" />
          </a-form-model-item> -->
        </div>
        <div class="subTil">商品详情信息</div>
        <a-form-model-item
          label="商品说明"
          prop="introduction"
          :labelCol="{ span: 2 }"
          :wrapperCol="{ span: 14 }"
        >
          <a-textarea
            v-model="form.introduction"
            type="textarea"
            placeholder="描述商品属性"
            rows="4"
            ref="descInputValue"
            @keyup="descpNum"
          />
          <span class="descNum">{{ form.introduction.length }}/1000</span>
        </a-form-model-item>
        <a-form-model-item
          label="商品轮播图"
          prop="imageUrls"
          :labelCol="{ span: 2 }"
          :wrapperCol="{ span: 14 }"
        >
          <div style="color: rgb(153, 153, 153)">
            图片建议尺寸<span style="color: rgb(217, 86, 114)">750*400</span
            >，每张图片不大于<span style="color: rgb(217, 86, 114)">2M</span
            >，最多可上传<span style="color: rgb(217, 86, 114)">9张</span
            >图，第一张为主图，支持jpg/png。
          </div>
          <a-upload
            list-type="picture-card"
            :before-upload="beforeUpload"
            :file-list="imageUrlsList"
            :customRequest="customRequestFile"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="imageUrlsList.length < 9">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-model-item>
        <a-form-model-item
          label="商品长图"
          :labelCol="{ span: 2 }"
          :wrapperCol="{ span: 14 }"
        >
          <div style="color: rgb(153, 153, 153)">
            长图建议尺寸<span style="color: rgb(217, 86, 114)">800*1200</span
            >，图片不大于<span style="color: rgb(217, 86, 114)">2M</span>。
          </div>
          <a-upload
            list-type="picture-card"
            :before-upload="beforeUpload1"
            :file-list="detailUrls"
            :customRequest="customRequestFile1"
            @preview="handlePreview1"
            @change="handleChange1"
          >
            <div v-if="detailUrls.length < 9">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible1"
            :footer="null"
            @cancel="handleCancel1"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 2 }">
          <a-button style="margin-right: 1rem" @click="back"> 取消 </a-button>
          <a-button type="primary" @click="onSubmit"> 确认 </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import req from '../../../../utils/request.js'
import {
  getBlocClassifyStateList,
  updateBlocGoods,
  getCouponInfo
} from '../../../../api/goods.js'
import local from '../../../../utils/local.js'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  data() {
    const validateRule = (rule, value, callback) => {
      if (this.form.basePrice === undefined) {
        callback(new Error('请填写商品原价！'))
        return false
      }
      const num = Number(this.form.basePrice)
      if (num > 999999.99) {
        callback(new Error('商品原价不应大于999999.99'))
        return false
      }
      if (num < 0) {
        callback(new Error('商品原价不应小于0'))
        return false
      }

      callback()
    }
    const validatediscountRule = (rule, value, callback) => {
      if (this.buyType === 'CASH') {
        if (this.form.discountPrice === undefined) {
          callback(new Error('请填写商品折扣价！'))
          return false
        }
        const num = Number(this.form.discountPrice)
        if (num > 999999.99) {
          callback(new Error('商品折扣价不应大于999999.99'))
          return false
        }
        if (num < 0) {
          callback(new Error('商品原价不应小于0'))
          return false
        }
      } else {
        var num = Number(this.form.discountPrice)
        var flag = new RegExp('^[1-9][0-9]*$').test(num)
        if (!flag) {
          callback(new Error('商品折扣价应为整数'))
          return false
        }
      }
      callback()
    }
    const validatecostRule = (rule, value, callback) => {
      const num = Number(this.form.costPrice)
      if (num > 999999.99) {
        callback(new Error('成本价不应大于999999.99'))
        return false
      }
      if (num < 0) {
        callback(new Error('成本价不应小于0'))
        return false
      }

      callback()
    }
    return {
      parentId: '',
      flag: false, // 实物商品与虚拟商品切换
      categoryList: [],
      imageUrlsList: [],
      detailUrls: [],
      form: {
        imageUrlsList: [],
        detailUrls: '',
        goodsTypeString: 'PHYSICAL'
      },
      previewVisible: false,
      previewVisible1: false,
      previewImage: '',
      rules: {
        name: [
          {
            required: true,
            message: '请输入商品名称！',
            trigger: 'blur'
          },
          {
            min: 0,
            max: 30,
            message: '名称长度在0-30！',
            trigger: 'blur'
          }
        ],
        basePrice: [
          {
            required: true,
            validator: validateRule,
            trigger: ['change', 'blur']
          }
        ],
        costPrice: [
          {
            required: true,
            validator: validatecostRule,
            trigger: ['change', 'blur']
          }
        ],
        discountPrice: [
          {
            required: true,
            validator: validatediscountRule,
            trigger: ['change', 'blur']
          }
        ],
        transExpense: [
          {
            required: true,
            message: '请填写商品运费！',
            trigger: 'blur'
          }
        ],
        categoryId: [
          {
            required: true,
            message: '请选择商品分类！',
            trigger: 'change'
          }
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请选择配送方式！',
            trigger: 'change'
          }
        ],
        introduction: [
          {
            required: true,
            message: '请描述商品属性！',
            trigger: 'blur'
          },
          {
            min: 0,
            max: 1000,
            message: '商品描述长度限制在1000个字符以内',
            trigger: 'blur'
          }
        ],
        imageUrlsList: [
          {
            required: true,
            message: '请上传图片!',
            trigger: 'blur'
          }
        ]
      },
      descNum: 0,
      inpNum: 0,
      // 选中分类
      checkedcategory: [],
      couponShowName: '',
      couponInfo: {},
      isInserts: false,
      cateList: '',
      buyType: '',
      uploadUrl: process.env.VUE_APP_API_URL_OSS,
      output: {
        subDirectory: '/mall/bloc',
        width: '960',
        quality: 1,
        type: 'ImgOutput'
      },
      isUpdate: false,
      isUpload: false
    }
  },
  created() {
    this.parentId = local.get('blocId')
    if (this.$route.params.browse) {
      this.form = JSON.parse(local.get('saveForm'))
      this.imageUrlsList = []
      this.imageUrlsList = JSON.parse(local.get('saveImg'))
      this.detailUrls = JSON.parse(local.get('saveDetail'))
    } else {
      this.form = this.$route.params.info
      if (this.form.imageUrlsList !== null) {
        if (this.form.imageUrlsList.length !== 0) {
          this.form.imageUrlsList.forEach((item, i) => {
            this.imageUrlsList.push({
              uid: i,
              name: 'imageList',
              status: 'done',
              url: item
            })
          })
        }
      }
      if (this.form.detailUrlsList !== null) {
        if (this.form.detailUrlsList.length !== 0) {
          this.form.detailUrlsList.forEach((item, i) => {
            this.detailUrls.push({
              uid: i,
              name: 'imageList',
              status: 'done',
              url: item
            })
          })
        }
      }
    }
    this.inpNum = this.form.name.length
    this.descNum = this.form.introduction.length
    this.getClassifyList(this.parentId)
    if (this.$route.params.conpon) {
      this.couponShowName = this.$route.params.conpon[0].couponShowName
      this.form.virtualGoodsTypeString = 'COUPON'
      this.form.virtualRelateId = this.$route.params.conpon[0].couponCode
    }
    if (this.form.virtualRelateId) {
      this.fn()
    }
    setTimeout(() => {
      this.cateList.forEach(item => {
        if (item.id === this.form.categoryId) {
          this.buyType = item.buyTypeString
        }
      })
    }, 200)
  },
  methods: {
    async fn() {
      const data = await getCouponInfo({
        couponCode: this.form.virtualRelateId
      })
      this.couponInfo = data.data
      this.couponShowName = data.data.couponShowName
    },
    back() {
      this.$router.push({
        path: '/commodity/man'
      })
    },
    // 获取可选择的虚拟商品
    chooseVirtualGoods() {
      local.set('saveForm', JSON.stringify(this.form))
      local.set('saveDetail', JSON.stringify(this.detailUrls))
      local.set('saveImg', JSON.stringify(this.imageUrlsList))
      this.$router.push({
        name: 'choose',
        params: {
          info: this.couponInfo,
          isInserts: this.isInserts
        }
      })
    },
    async getClassifyList(temp) {
      const data = await getBlocClassifyStateList({
        parentId: temp,
        mallTypeString: 'BLOC'
      })
      this.cateList = data.data
      data.data.forEach(item => {
        this.categoryList.push({
          code: item.id,
          name: item.categoryName,
          mallId: item.mallId
        })
      })
    },
    // 选择分类
    selectClassify(v) {
      this.cateList.forEach(item => {
        if (item.id === v) {
          this.buyType = item.buyTypeString
        }
      })
      this.checkedcategory = this.categoryList.filter(item => {
        return item.code === v
      })
      this.form.categoryName = this.checkedcategory[0].name
    },
    // 输入框文字数量计算
    nameInpNum() {
      this.inpNum = this.$refs.nameInputValue.value
        ? this.$refs.nameInputValue.value.length
        : 0
    },
    onSubmit() {
      const self = this
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          self.form.mallId = this.form.mallId
          self.form.imageUrlsList = []
          self.form.detailUrlsList = []
          if (self.imageUrlsList.length !== 0) {
            self.imageUrlsList.forEach(item => {
              if (item.response === undefined) {
                self.form.imageUrlsList.push(item.url)
              } else {
                self.form.imageUrlsList.push(
                  item.response.data.baseUrl + item.response.data.fileName
                )
              }
            })
          }
          if (self.detailUrls.length !== 0) {
            self.detailUrls.forEach(item => {
              if (item.response === undefined) {
                self.form.detailUrlsList.push(item.url)
              } else {
                self.form.detailUrlsList.push(
                  item.response.data.baseUrl + item.response.data.fileName
                )
              }
            })
          }
          var imgFlag = true
          self.imageUrlsList.forEach(item => {
            if (item.status !== 'done') {
              imgFlag = false
            }
          })
          if (imgFlag) {
            const data = await updateBlocGoods(
              self.form,
              self.$route.params.parentId
            )
            if (data.code === 0) {
              this.$message.success(data.message)
              this.$router.push({
                path: '/commodity'
              })
            }
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 备注文字数量计算
    descpNum() {
      this.descNum = this.$refs.descInputValue.value
        ? this.$refs.descInputValue.value.length
        : 0
    },
    // 上传图片
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    beforeUpload(file, UpFileList) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('文件大小超过最大限度2M')
        file.status = 'error'
        return false
      }
    },
    beforeUpload1(file, UpFileList) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('文件大小超过最大限度2M')
        file.status = 'error'
        return false
      }
    },
    // 获取图片宽高
    loadPic (file) {
      var that = this
      var fileData = file
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        var image = new Image()
        image.src = data
        image.onload = function () {
          var width = image.width
          that.output.width = width
        }
      }
      reader.readAsDataURL(fileData)
    },
    // 轮播图上传
    customRequestFile (options) {
      this.isUpload = true
      this.loadPic(options.file)
      if (options.file.size > 2 * 1024 * 1024) {
        this.$message.warning('文件大小超过最大限度1G')
        file.status = 'error'
        return false
      }
      setTimeout(() => {
        const formData = new FormData()
        formData.append('file', options.file)
        formData.append('subDir', '/mall/bloc')
        req.uploadForm(this.uploadUrl, formData).then((value) => {
          if (value.code === 'OSS-SERVER-20000') {
            // options.onSuccess(value, options.file)
            this.imageUrlsList.push({
              uid: Math.random(),
              name: 'imageList',
              status: 'done',
              url: value.data
            })
            this.isUpload = false
            this.$forceUpdate()
          }
        })
      }, 500)
    },
    handleChange({ fileList }) {
      if (!this.isUpload) {
        this.imageUrlsList = [...fileList]
      }
    },
    handleCancel1() {
      this.previewVisible = false
    },
    async handlePreview1(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    // 商品长图上传
    customRequestFile1 (options) {
      this.isUpdate = true
      this.loadPic(options.file)
      if (options.file.size > 2 * 1024 * 1024) {
        this.$message.warning('文件大小超过最大限度1G')
        file.status = 'error'
        return false
      }
      setTimeout(() => {
        const formData = new FormData()
        formData.append('file', options.file)
        formData.append('subDir', '/mall/bloc')
        req.uploadForm(this.uploadUrl, formData).then((value) => {
          if (value.code === 'OSS-SERVER-20000') {
            // options.onSuccess(value, options.file)
            this.detailUrls.push({
              uid: Math.random(),
              name: 'imageList',
              status: 'done',
              url: value.data
            })
            this.isUpdate = false
            this.$forceUpdate()
          }
        })
      }, 500)
    },
    handleChange1({ fileList }) {
      if (!this.isUpdate) {
        this.detailUrls = [...fileList]
      }
    }
  },
  computed: {
    headers() {
      return {
        token: local.get('token')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@baseColor: #4196ff;
.index_wrapper {
  text-align: left;
  padding: 2.2rem 1.6rem 0 1.6rem;
  width: 100%;
  .title {
    font-size: 18px;
    padding-bottom: 1.8rem;
  }
  .subTil {
    font-size: 16px;
    padding-bottom: 1rem;
  }
  .content {
    // background-color: #fff;
    padding: 1rem 0 2.4rem 1.2rem;
    // border: 1px solid rgb(234, 234, 234);
    .form {
      display: flex;
      flex-wrap: wrap;
      .ant-form-item {
        width: 50%;
        /deep/.ant-select-selection--single {
          width: 100% !important;
        }
        &:nth-child(2) {
          width: 100%;
        }
      }
    }
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
}
.index_wrapper .content .form .ant-form-item {
  margin-bottom: 1rem !important;
}
</style>
